import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "market-ribbon" }
const _hoisted_2 = { class: "market-ribbon__status" }

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import { MarketState } from '@exchange/libs/market/service/src';

export interface TextObjFromLokalise {
  SUSPENDED?: string | { href: string; text: string };
  IN_MAINTENANCE?: string | { href: string; text: string };
  NEW?: string | { href: string; text: string };
  POST_ONLY?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MarketRibbon',
  props: {
  marketName: { type: String, required: false },
  marketState: { type: String as PropType<MarketState>, required: false },
},
  setup(__props) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });

const getTextFrom = (property: TextObjFromLokalise, marketState: MarketState | undefined) => {
  if (!marketState) {
    return undefined;
  }

  switch (marketState) {
    case MarketState.SUSPENDED:
      return property.SUSPENDED;
    case MarketState.IN_MAINTENANCE:
      return property.IN_MAINTENANCE;
    case MarketState.NEW:
      return property.NEW;
    case MarketState.POST_ONLY:
      return property.POST_ONLY;
    default:
      return undefined;
  }
};

const ribbonTexts = computed(() => ({
  SUSPENDED: props.marketName ? t('modules.market.suspended.ribbon.text', { market: props.marketName }) : '',
  IN_MAINTENANCE: props.marketName ? t('modules.market.inMaintenance.ribbon.text', { market: props.marketName }) : '',
  NEW: undefined,
}));
const ribbonText = computed(() => getTextFrom(ribbonTexts.value, props.marketState));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(ribbonText.value), 1)
  ]))
}
}

})